import React from "react";

import { IAcademyDocumentFolder2AppUser } from "../../Models/IAcademyDocument2AppUser";

// Internationalization Import
import i18n from "i18next";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";
import {
  Button,
  Checkbox,
  createTableColumn,
  Link,
  Persona,
  TableCellLayout,
  TableColumnDefinition,
  Tooltip,
  Text,
} from "@fluentui/react-components";
import { Delete24Filled } from "@fluentui/react-icons";

interface IAcademyDocumentFolderParticipantColumnsProps {
  isAdmin: boolean;
  onChange(): void;
  onAddCertificateClicked(guid: string): any;
  onDocumentClicked(doc: any): void;
  academyDocumentFolderGuid: string;
}

export function AcademyDocumentFolderParticipantColumns(
  props: IAcademyDocumentFolderParticipantColumnsProps
) {
  const deleteAcademyParticipant = (userGuid: string) => {
    if (userGuid) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/academy/RemoveAppUserFromFolder?appUserGuid=${userGuid}&academyDocumentFolderGuid=${props.academyDocumentFolderGuid}`
        )
        .then(() => {
          props.onChange();
        });
    }
  };

  const deleteCertificate = (userGuid: string) => {
    if (userGuid) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/academy/DeleteCertificate?appUserGuid=${userGuid}&academyDocumentFolderGuid=${props.academyDocumentFolderGuid}`
        )
        .then(() => {
          props.onChange();
        });
    }
  };

  const setUserIsObserver = (userGuid: string, isObserver: boolean) => {
    if (userGuid) {
      fetchWrapper
        .getWithAuth(
          `${baseUrl}/api/academy/SetUserIsObserver?appUserGuid=${userGuid}&academyDocumentFolderGuid=${props.academyDocumentFolderGuid}&isObserver=${isObserver}`
        )
        .then(() => {
          props.onChange();
        });
    }
  };

  const columns: TableColumnDefinition<IAcademyDocumentFolder2AppUser>[] = [
    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "persona",

      renderHeaderCell: () => "",
      renderCell: (item) => {
        return (
          <Persona
            name={item.appUser?.fullName}
            secondaryText={item.appUser?.firma}
          />
        );
      },
    }),
    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "fullName",

      renderHeaderCell: () => "Name",
      renderCell: (item) => {
        return (
          <TableCellLayout>
            <Text>{item.appUser?.fullName}</Text>
          </TableCellLayout>
        );
      },
    }),

    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "email",

      renderHeaderCell: () => "E-Mail",
      renderCell: (item) => {
        return (
          <TableCellLayout>
            <Text>{item.appUser?.email}</Text>
          </TableCellLayout>
        );
      },
    }),

    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "certificate",

      renderHeaderCell: () => i18n.t<string>("certificate"),
      renderCell: (item) => {
        if (item.userDocumentGuid) {
          return (
            <TableCellLayout>
              <Link
                onClick={() =>
                  props.onDocumentClicked({
                    path: item.userDocument.docPath.replace(
                      "~",
                      baseUrl + "/api/documents/GetDocumentFromPath?path="
                    ),
                    title: item.userDocument.displayDocFileName,
                  })
                }
              >
                {item.userDocument.displayDocFileName}
              </Link>

              <Tooltip
                content={i18n.t<string>("deleteCertificate")}
                relationship={"label"}
              >
                <Button
                  icon={<Delete24Filled />}
                  onClick={() => {
                    deleteCertificate(item.appUserGuid);
                  }}
                />
              </Tooltip>
            </TableCellLayout>
          );
        } else {
          return (
            <TableCellLayout>
              {props.isAdmin && !item.isObserver && (
                <Button
                  appearance="primary"
                  onClick={() => {
                    props.onAddCertificateClicked(item.appUserGuid);
                  }}
                >
                  {i18n.t<string>("addCertificate")}
                </Button>
              )}
            </TableCellLayout>
          );
        }
      },
    }),
    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "isObserver",

      renderHeaderCell: () => i18n.t("isObserver"),
      renderCell: (item) => {
        if (props.isAdmin) {
          return (
            <Checkbox
              checked={item.isObserver ? item.isObserver : false}
              onChange={(ev, data) => {
                setUserIsObserver(
                  item.appUserGuid,
                  data.checked ? true : false
                );
              }}
              label={i18n.t("isObserver")}
            />
          );
        } else {
          return <div></div>;
        }
      },
    }),
    createTableColumn<IAcademyDocumentFolder2AppUser>({
      columnId: "delete",

      renderHeaderCell: () => "",
      renderCell: (item) => {
        if (props.isAdmin) {
          return (
            <Tooltip content={i18n.t<string>("delete")} relationship={"label"}>
              <Button
                appearance="transparent"
                icon={<Delete24Filled />}
                onClick={() => {
                  deleteAcademyParticipant(item.appUserGuid);
                }}
              />
            </Tooltip>
          );
        } else {
          return <div></div>;
        }
      },
    }),
  ];

  return columns;
}
